export default __webpack_public_path__ + "static/media/air_condition.72d3dc24.svg";